<template>
  <div>
    <mdb-btn @click="$emit('finished')" icon="arrow-left">Back to Console</mdb-btn>
    <mdb-btn @click="listTargets" icon="recycle">Refresh</mdb-btn>
    <mdb-card v-if="!currentBalancer">
      <mdb-card-header class="secondary-color-dark text-white">
        <h4>Select a Load Balancer</h4>
      </mdb-card-header>
      <mdb-card-body v-if="loadBalancers">
        <div v-for="(b,i) in loadBalancers" :key="i">
          <mdb-btn @click="selectBalancer(b)" icon="check">{{ b.loadBalancerName }}</mdb-btn>
        </div>

      </mdb-card-body>
    </mdb-card>

    <mdb-card v-if="currentBalancer">
      <mdb-card-header class="secondary-color-dark text-white">
        <h5>Current Listener Targets -> {{ currentBalancer.loadBalancerName }}</h5>
        <span>{{ currentBalancer.loadBalancerArn }}</span>
      </mdb-card-header>
      <mdb-card-body v-if="listener">
        <div class="text-info">HTTPS:443 Listener: {{ listener.httpsListener }}</div>
        <mdb-tbl>
          <mdb-tbl-head>
            <tr>
              <th>Rule Seq#</th>
              <th>Conditions</th>
              <th>Actions</th>
            </tr>
          </mdb-tbl-head>
          <mdb-tbl-body>
            <tr v-for="(rule,i) in listener.listenerRules" :key="i">
              <td>{{ rule.priority }}</td>
              <td>
                <span v-for="(cond,j) in rule.conditions" :key="j">
                  <span v-if="cond.field == 'host-header' && cond.hostHeaderConfig">
                    <h5>Hosts:</h5>
                    <div v-for="(val,k) in cond.hostHeaderConfig.values" :key="k">
                      {{ val }}
                    </div>
                  </span>
                  <span v-if="cond.field == 'http-header'">
                    {{ cond.httpHeaderConfig }}
                  </span>
                </span>
              </td>
              <td>
                <span v-for="(action,i) in rule.actions" :key="i">
                  <span v-if="action.type=='fixed-response'">
                    {{ action.fixedResponseConfig }}
                  </span>
                  <span v-if="action.type=='forward'">
                    <h5>Forward</h5>
                    <div v-for="(target,j) in action.forwardConfig.targetGroups" :key="j">
                      {{ target.weight }} -- {{ formatTargetGroup(target.targetGroupArn) }}
                      <div v-for="(t,k) in listener.validTargets" :key="k">
                        <mdb-btn v-if="t.targetGroupArn != target.targetGroupArn"
                                 size="sm" rounded @click="changeTarget(rule,target,t)">Switch to
                          {{ t.targetGroupName }}
                        </mdb-btn>
                      </div>
                    </div>
                  </span>
                </span>
              </td>

            </tr>
          </mdb-tbl-body>
        </mdb-tbl>
      </mdb-card-body>
      <mdb-card-footer>
        <mdb-btn @click="clearBalancer">Change Balancer</mdb-btn>
      </mdb-card-footer>
    </mdb-card>

  </div>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbContainer,
  mdbInput,
  mdbTbl,
  mdbTblBody,
  mdbTblHead
} from 'mdbvue';

export default {
  name: "admin-aws-lbtargets",
  display: "Targets",
  order: 1,
  components: {
    mdbContainer,
    mdbInput,
    mdbBtn,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardFooter,
    mdbTbl,
    mdbTblBody,
    mdbTblHead
  },
  computed: {
    userDetails: function () {
      return this.$store.state.userDetails
    }
  },
  async mounted() {
    let saved = localStorage.getItem("last-load-balancer")
    if (saved) this.currentBalancer = JSON.parse(saved)
    if (!this.currentBalancer) this.listLoadBalancers()
    else this.listTargets()
  },
  data() {
    return {
      currentBalancer: null,
      loadBalancers: null,
      targets: null,
      listener: null
    }
  },
  methods: {
    formatTargetGroup(t) {
      if (!t) return "???"
      let parts = t.split("/")
      if (parts.length >= 2) return parts[1]
      else return t
    },
    selectBalancer(bal) {
      this.currentBalancer = bal
      localStorage.setItem("last-load-balancer", JSON.stringify(this.currentBalancer))
      this.listTargets()
    },
    clearBalancer() {
      this.currentBalancer = null
      localStorage.removeItem("last-load-balancer")
      this.listLoadBalancers()
    },
    changeTarget(rule, oldTarget, newTarget) {
      console.log("Rule is ", rule)
      if (rule.actions.length != 1) {
        this.$notify.error({message: "We only support rules with 1 action right now." + rule.actions.length})
        return
      }
      /*for (let a of rule.actions) {
       if (a.forwardConfig) {
       if (a.forwardConfig.targetGroupArn == oldTarget.targetGroupArn) {
       changed = true
       a.forwardConfig.targetGroupArn = newTarget.targetGroupArn
       }*/


      this.$store.dispatch("setExecuting", true)
      api.post("/aws/listenerRule/", {
        ruleArn: rule.ruleArn,
        newTarget: newTarget.targetGroupArn,
        loadBalancerArn: this.currentBalancer.loadBalancerArn,
        action: rule.actions[0]
      }).then(
        (details) => {
          this.listener = details.data
        },
        (error) => {
          this.$notify.error({message: error.response.data})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    listTargets() {
      this.$store.dispatch("setExecuting", true)
      api.post("/aws/lbTargets/", {arn: this.currentBalancer.loadBalancerArn}).then(
        (details) => {
          this.listener = details.data
        },
        (error) => {
          this.$notify.error({message: error.response.data})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    listLoadBalancers() {
      this.$store.dispatch("setExecuting", true)
      api.get("/aws/balancers").then(
        (details) => {
          this.loadBalancers = details.data.loadBalancers
        },
        (error) => {
          this.$notify.error({message: error.response.data})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
  }

}
;
</script>
